import { render, staticRenderFns } from "./CategoryItem.vue?vue&type=template&id=c671802e&"
import script from "./CategoryItem.vue?vue&type=script&lang=js&"
export * from "./CategoryItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c671802e')) {
      api.createRecord('c671802e', component.options)
    } else {
      api.reload('c671802e', component.options)
    }
    module.hot.accept("./CategoryItem.vue?vue&type=template&id=c671802e&", function () {
      api.rerender('c671802e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/categories/CategoryItem.vue"
export default component.exports